<template>
  <component
      :is="tag"
      :class="computedClass"
      @click="handleClick"
      :title="tooltip"
  >
    <slot>{{ displayText }}</slot>
  </component>
</template>

<script>
export default {
  name: 'ClickableLink',
  props: {
    id: {
      type: [Number, String],
      required: true
    },
    resource: {
      type: String,
      required: true,
      validator: function (value) {
        return ['Guidance', 'Labourer', 'User', 'Role', 'Vendor', 'Schedule', 'Tariff', 'Workplace', 'Activity', 'Labourer Payment','Permission'].includes(value);
      }
    },
    text: {
      type: [String, Number],
      default: null
    },
    routeName: {
      type: String,
      default: null
    },
    tag: {
      type: String,
      default: 'strong'
    },
    customClass: {
      type: [String, Array, Object],
      default: ''
    },
    tooltip: {
      type: String,
      default: 'Click to view'
    },
    stopPropagation: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: function () {
        return {};
      }
    },
    query: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  computed: {
    displayText: function () {
      return this.text !== null ? this.text : this.id;
    },
    computedClass: function () {
      var classes = ['clickable-link'];

      if (typeof this.customClass === 'string') {
        classes.push(this.customClass);
      } else if (Array.isArray(this.customClass)) {
        classes = classes.concat(this.customClass);
      } else if (typeof this.customClass === 'object') {
        Object.keys(this.customClass).forEach(function (key) {
          if (this.customClass[key]) {
            classes.push(key);
          }
        }, this);
      }

      return classes;
    },
    resolvedRouteName: function () {
      if (this.routeName) {
        return this.routeName;
      }

      // Auto-resolve route name based on resource type
      var routeMap = {
        'Guidance': 'View Guidance',
        'Labourer Payment': 'View Labourer Payment',
        'Labourer Schedule': 'View Labourer Schedule',
        'Labourer': 'View Labourer',
        'User': 'View User',
        'Role': 'View Role',
        'Permission': 'View Permission',
        'Vendor': 'View Vendor',
        'Schedule': 'View Schedule',
        'Tariff': 'View Tariff',
        'Workplace': 'View Workplace',
        'Activity': 'View Activity'
      };

      return routeMap[this.resource] || null;
    }
  },
  methods: {
    handleClick: function (event) {
      if (this.stopPropagation) {
        event.stopPropagation();
      }

      if (!this.resolvedRouteName) {
        console.warn('ClickableLink: No route name resolved for resource:', this.resource);
        return;
      }

      // Build route params
      var routeParams = Object.assign({}, this.params, {id: this.id});

      // Navigate to route
      this.$router.push({
        name: this.resolvedRouteName,
        params: routeParams,
        query: this.query
      }).catch(function (error) {
        if (error.name !== 'NavigationDuplicated') {
          console.error('Navigation error:', error);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/md/_variables.scss';

.clickable-link {
  color: $brand-primary;
  cursor: pointer;
  text-decoration: none;
  transition: color $transition-base;
  font-weight: $font-weight-semibold;

  &:hover {
    color: $brand-primary-dark;
    text-decoration: underline;
  }

  &:active {
    color: $brand-primary-darker;
  }

  // Optional: Add icon support
  &::after {
    content: '';
    display: inline-block;
    width: 0;
    height: 0;
    transition: width $transition-base;
  }

  &:hover::after {
    // Add arrow on hover if desired
    // content: ' →';
    // width: auto;
  }

}
</style>
